import { z } from 'zod';

/**
 * The COLLECTION the source doc lives in. 7-value enum used across every
 * new Party snapshot (`Party.target`).
 *
 * Historically this file existed to break a circular import between
 * `party.schema.ts` and the now-deleted `relation.schema.ts`. Post
 * Auth-v2 hard cutover, `relation.schema.ts` is gone and this file
 * could be inlined into `party.schema.ts` — it remains its own file
 * only to minimize churn on the many callsites that import `Target`
 * from `@hero/schema`.
 *
 * See `docs/relations-v2/02-data-model.md` section 4 for the legacy → new
 * migration table.
 *
 * - `org`         → `Org` collection (unifies legacy Business + Carrier)
 * - `user`        → `User` collection (any role)
 * - `client`      → `Client` collection (unifies legacy Customer)
 * - `driver`      → `Driver` collection
 * - `contact`     → `Contact` collection
 * - `profile`     → `Profile` collection (global admin-curated brand directory)
 * - `super_admin` → `AdminUser` collection (Hero system / staff)
 */
export const targetSchema = z.enum([
  'org',
  'user',
  'client',
  'driver',
  'contact',
  'profile',
  'super_admin',
]);
export type Target = z.infer<typeof targetSchema>;
